var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportAlternative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.7,6.3c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8,0-.1,0-.2.1-.3.2l-4,4c-.1.1-.2.2-.2.3-.1.1-.1.3-.1.4s0,.3.1.4c0,.1.1.2.2.3s.2.2.3.2.3.1.4.1.3,0,.4-.1c.1-.1.2-.1.3-.2l2.3-2.3v11.6c0,.3.1.5.3.7s.4.3.7.3.5-.1.7-.3c.2-.2.3-.4.3-.7v-11.6l2.3,2.3c.1.1.2.2.3.2s.3.1.4.1.3,0,.4-.1.2-.1.3-.2c.1-.1.2-.2.2-.3s.1-.3.1-.4,0-.3-.1-.4c0-.1-.1-.2-.2-.3,0,0-4-4-4-4Zm6.3-4.3H5c-.3,0-.5.1-.7.3-.2.2-.3.4-.3.7s.1.5.3.7c.2.2.4.3.7.3h14c.3,0,.5-.1.7-.3.2-.2.3-.4.3-.7s-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportAlternative);
export default __webpack_public_path__ + "static/media/import-alternative.cde8d62a100b68fe357b968698e1cad2.svg";
export { ForwardRef as ReactComponent };